import api from '../configurations/axios';
import AutoEntryResult from '../responses/AutoEntryResult';

class AutoEntriesService {
    async addAutoEntries(competitionId: number, entriesPerMember: number): Promise<AutoEntryResult[]> {
        const response = await api.post<AutoEntryResult[]>(`/api/winners/auto-entries/${competitionId}`, {
            entriesPerMember,
        });
        return response.data;
    }
}

export default new AutoEntriesService();
